<div
  class="modal-overlay"
  (click)="closeModal($event)"
  [class.position-left]="position === 'left'"
  [class.position-right]="position === 'right'"
>
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ title }}</h2>
      <button type="button" class="close-button" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div class="modal-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
